import type { BaseEntityState, AuditFields } from '@crm/shared';

/**
 * MEETING — Entita' di engagement "riunione" del CRM, agganciabile a
 * Person/Business tramite Relationship polimorfica. Schema allineato a
 * rest-openapi.yaml (componente `Meeting`/`MeetingInput`).
 *
 * Niente `direction` (a differenza di Call). `duration` e' un int32 in
 * minuti; il form ha preset comuni (15/30/45/60/90/120) + custom.
 *
 * SYNC CROSS-LAYER — modifiche vanno replicate in parallelo su:
 *   MeetingStatus: modules/crm-util/.../MeetingStatus.java,
 *                  meetingMappers.ts (MEETING_STATUS_TO_INT),
 *                  locales/{it,en}.json (meeting.statuses.*)
 */
export type MeetingStatus =
  | 'planned'
  | 'replanned'
  | 'missing'
  | 'cancelled'
  | 'completed';

export const MEETING_STATUSES: { value: MeetingStatus; label: string }[] = [
  { value: 'planned', label: 'meeting.statuses.planned' },
  { value: 'replanned', label: 'meeting.statuses.replanned' },
  { value: 'completed', label: 'meeting.statuses.completed' },
  { value: 'missing', label: 'meeting.statuses.missing' },
  { value: 'cancelled', label: 'meeting.statuses.cancelled' },
];

/** Preset di durata comuni (minuti) per il form. */
export const MEETING_DURATION_PRESETS: { value: number; label: string }[] = [
  { value: 15, label: 'meeting.durationPresets.min15' },
  { value: 30, label: 'meeting.durationPresets.min30' },
  { value: 45, label: 'meeting.durationPresets.min45' },
  { value: 60, label: 'meeting.durationPresets.hour1' },
  { value: 90, label: 'meeting.durationPresets.hour1h30' },
  { value: 120, label: 'meeting.durationPresets.hour2' },
];

export interface Meeting extends AuditFields {
  meetingId: number;
  meetingDate: string;
  duration: number;
  title?: string;
  description: string;
  location?: string;
  notes?: string;
  status: MeetingStatus;
}

export interface MeetingState extends BaseEntityState<Meeting> {
  filters: {
    status?: MeetingStatus;
  };
  totalCount: number;
}

export interface MeetingCreatePayload {
  meetingDate: string;
  duration: number;
  description: string;
  status: MeetingStatus;
}

export interface MeetingUpdatePayload extends Partial<MeetingCreatePayload> {
  meetingId: number;
}
